<template>
  <div
    class="recomend_list final"
    :class="pcOpen"
  >
    <div
      class="item_box"
      :class="classMinHeight"
    >
      <div class="item_header">
        <p>최종 제품 정보</p>
        <div>
          <p><em>1일 총 {{ totalPhilsPerDay }}정/캡슐</em>
            <span>(총 {{ totalPockets }}포)</span></p>
          <p>{{ packItemsTextSummary }}</p>
        </div>
      </div>
      <div
        class="item_foot"
        :class="changeDetailState"
      >
        <p class="total_price">
          <em><mpn-label-number :amount="totalPrice" /></em> 원
        </p>
        <span class="small_text">PV/BV <mpn-label-number
          :amount="totalPV"
        />/<mpn-label-number
          :amount="totalBV"
        /></span>
        <button
          type="button"
          class="btn_open"
          @click="showDetail"
        >
          자세히 보기
        </button>
        <slot />
      </div>
      <final-applied-item-info-detail :products-by-group="productsByGroup" />
    </div>
  </div>
</template>

<script>
import { DOUBLE_X_SKU } from '@/utils/constants';
import FinalAppliedItemInfoDetail from '@/components/final-check/FinalAppliedItemInfoDetail';
import productHelpers from '@/utils/helpers/product';
import { mapGetters } from 'vuex';

export default {
  name: 'FinalAppliedItemInfo',
  components: {
    FinalAppliedItemInfoDetail,
  },
  props: {
    desktop: {
      type: Boolean,
      default: false,
    },
    activeButton: {
      type: String,
      default: 'active',
    },
    requireMinHeight: {
      type: Boolean,
      default: false,
    },
    finalProducts: {
      type: Array,
      default: () => [],
    },
    days: {
      type: Number,
      default: 0,
    },
    pockets: {
      type: Number,
      default: 0,
    },
    prices: {
      type: Object,
      default: () => ({}),
    },

  },
  data() {
    return {
      changeDetailState: this.activeButton,
      productsByGroup: [],
    };
  },
  computed: {
    ...mapGetters({
      products: 'product/products',
    }),
    pcOpen() {
      return this.desktop ? 'pc_open' : '';
    },
    classMinHeight() {
      return this.requireMinHeight ? 'min-height' : '';
    },
    totalPhilsPerDay() {
      return this.finalProducts.reduce(
        (acc, n) => acc + productHelpers
          .parseSeq(n.seq)
          .reduce((acc2, x) => acc2 + (n.item_sku === DOUBLE_X_SKU ? x * 3 : x),
            0),
        0,
      );
    },
    totalPhils() {
      return this.totalPhilsPerDay * this.days;
    },
    totalPockets() {
      return this.days * this.pockets;
    },
    totalPrice() {
      if (this.prices === null) { return ' - '; }
      return this.prices.price;
    },
    totalPV() {
      if (this.prices === null) { return ' - '; }
      return this.prices.pv;
    },
    totalBV() {
      if (this.prices === null) { return ' - '; }
      return this.prices.bv;
    },
    packItemsTextSummary() {
      const summary = [];
      this.finalProducts.forEach((n) => {
        summary.push(
          this.products
            .find((f) => f.item_sku === n.item_sku).item_name,
        );
      });
      return summary.join(',');
    },
  },
  created() {
    console.log(this.finalProducts);
    this.productsByGroup = productHelpers
      .splitProductsByDoesGroup(this.products, this.finalProducts, this.pockets);
  },
  methods: {
    showDetail() {
      if (this.changeDetailState === 'active') {
        this.changeDetailState = '';
      } else {
        this.changeDetailState = 'active';
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {

}
@media (min-width: 769px) {
  .recomend_list .item_box.min-height {
    min-height: 470px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/final-check/FinalAppliedItemInfo.vue